import { Typography, Tooltip } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import PurchaseOrders from 'types/entities/PurchaseOrders';
import { getPurchaseOrderAction } from 'store/actions/purchaseOrderActions';
import Switches from 'components/SwitchComponent/Switches';

const ActionsCell = React.memo((row: PurchaseOrders) => {
  const state = useSelector((state) => state.purchaseOrder);
  const { dispatch } = useAppState();
  const [checked, setChecked] = React.useState(false);

  useEffect(() => {
    setChecked(!row?.is_archived);
  }, [row?.is_archived]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (state?.datas) {
      const updatedData: { datas: PurchaseOrders[] } = {
        datas: state?.datas?.map((order) => {
          let updatedIsValid = order.is_valid;
          let updateIsArchived = order.is_archived;
          // Check if this order matches the row
          if (order.id === row.id) {
            updateIsArchived = !order.is_archived;
            // If the checkbox is unchecked, set is_valid to false
            if (event.target.checked === false) {
              updatedIsValid = false;
            }
          }

          return {
            ...order,
            is_archived: updateIsArchived,
            is_valid: updatedIsValid,
          };
        }),
      };
      dispatch(getPurchaseOrderAction(updatedData?.datas));
    }
  };

  return (
    <>
      <Switches checked={checked} handleChange={handleChange} />
      <Typography noWrap variant="body2">
        {checked ? 'Active' : 'Inactive'}
      </Typography>
    </>
  );
});

export default ActionsCell;
